import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination as AntPagination } from 'antd';

export const getPaginationTotal = (total, range) => (range[0] && range[1] ? `${range[0]}-${range[1]} of ${total} items` : null)

class Pagination extends Component {
    render() {
        const {
            total, pageSize, current, pageSizeChanger, pageSizeOptions, showTotalSummary,
        } = this.props;
        return (
            <AntPagination
                pageSizeOptions={pageSizeOptions}
                showSizeChanger={pageSizeChanger}
                total={total}
                showTotal={(total, range) => (showTotalSummary ? `${range[0]}-${range[1]} of ${total} items` : null)}
                pageSize={pageSize}
                defaultPageSize={pageSize}
                current={current} />
        );
    }
}

Pagination.defaultProps = {
    total: 0,
    pageSize: 10,
    current: 1,
    pageSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40'],
    showTotalSummary: true,
};

Pagination.propTypes = {
    total: PropTypes.number,
    pageSize: PropTypes.number,
    current: PropTypes.number,
    pageSizeChanger: PropTypes.bool,
    pageSizeOptions: PropTypes.array,
    showTotalSummary: PropTypes.bool,
};

export default Pagination;
